import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import messages from './messages';
import styles from './ExtendWarrantyHeader.module.scss';

const ExtendWarrantyHeader = ({ productType }) => {
  const { formatMessage } = useIntl();
  const productTypes = {
    bed_frames: 'Bed Frame',
    mattress: 'Mattress',
    default: 'Product',
  };

  const warrantyProduct = productTypes[`${productType}`] || productTypes.default;

  return (
    <div
      className={styles.heading}
      role="region"
      aria-label="warranty-header"
    >
      {formatMessage(messages.warrantyHeading, { product: warrantyProduct })}
    </div>
  );
};

ExtendWarrantyHeader.propTypes = {
  productType: PropTypes.string.isRequired,
};

export default ExtendWarrantyHeader;
